import React, { useState } from 'react';
import { XIcon, ZoomInIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './FadeIn';
const galleryImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/7oHu3QEbxEGBXTqjq1ivrd/55489091_2321115041459648_8198244659915390976_o.jpg',
  alt: 'Apostle Phillips ministering during service',
  span: 'md:col-span-2 md:row-span-2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wsZabRN8ymxvHzMJMUaiEG/Apostlephillipsbookcoversession15of30-683x1024.jpg',
  alt: 'Apostle Akintunde Phillips portrait',
  span: 'md:row-span-2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bGuWuxBYqS8au4kzpt2mqK/early-will-i-1024x722.png',
  alt: 'Arise & Shine — Early Will I Seek Thee, 5:30 AM Mon–Fri',
  span: 'md:col-span-2'
}, {
  src: 'https://images.unsplash.com/photo-1438232992991-995b7058bbb3?q=80&w=800&auto=format&fit=crop',
  alt: 'Worship service',
  span: ''
}, {
  src: 'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?q=80&w=800&auto=format&fit=crop',
  alt: 'Bible study session',
  span: ''
}, {
  src: 'https://images.unsplash.com/photo-1445445290350-18a3b86e0b5b?q=80&w=800&auto=format&fit=crop',
  alt: 'Prayer gathering',
  span: 'md:col-span-2'
}, {
  src: 'https://images.unsplash.com/photo-1511649475669-e288648b2339?q=80&w=800&auto=format&fit=crop',
  alt: 'Community outreach',
  span: ''
}];
export function GallerySection() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  return <>
      <section id="gallery" className="py-24 md:py-32 bg-charcoal relative overflow-hidden" data-id="element-173">
        <div className="absolute inset-0 opacity-5 bg-[radial-gradient(circle_at_center,rgba(255,255,255,1)_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-174" />

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-175">
          <FadeIn className="text-center mb-16" data-id="element-176">
            <span className="text-gold font-semibold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-177">
              Moments
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-white" data-id="element-178">
              Gallery
            </h2>
            <p className="text-gray-400 font-inter text-lg mt-6 max-w-xl mx-auto" data-id="element-179">
              Capturing moments of worship, ministry, and community impact.
            </p>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-180">
            {galleryImages.map((image, index) => <FadeIn key={index} delay={index * 0.1} className={image.span} data-id="element-181">
                <button onClick={() => setSelectedImage(index)} className="group relative w-full h-full min-h-[240px] overflow-hidden rounded-sm block" aria-label={`View ${image.alt}`} data-id="element-182">
                  <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-183" />
                  <div className="absolute inset-0 bg-dark/0 group-hover:bg-dark/60 transition-colors duration-500 flex items-center justify-center" data-id="element-184">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center gap-2" data-id="element-185">
                      <ZoomInIcon className="w-8 h-8 text-gold" data-id="element-186" />
                      <span className="text-white text-sm font-inter tracking-wide" data-id="element-187">
                        {image.alt}
                      </span>
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 h-1 bg-gold scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" data-id="element-188" />
                </button>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      <AnimatePresence data-id="element-189">
        {selectedImage !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] bg-dark/95 backdrop-blur-md flex items-center justify-center p-6" onClick={() => setSelectedImage(null)} data-id="element-190">
            <button onClick={() => setSelectedImage(null)} className="absolute top-6 right-6 text-white hover:text-gold transition-colors z-10" aria-label="Close lightbox" data-id="element-191">
              <XIcon className="w-8 h-8" data-id="element-192" />
            </button>

            <motion.img initial={{
          scale: 0.8,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.8,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} src={galleryImages[selectedImage].src} alt={galleryImages[selectedImage].alt} className="max-w-full max-h-[85vh] object-contain rounded-sm shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-193" />

            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-center" data-id="element-194">
              <p className="text-white/80 font-inter text-sm" data-id="element-195">
                {galleryImages[selectedImage].alt}
              </p>
              <p className="text-gold/60 text-xs mt-1" data-id="element-196">
                {selectedImage + 1} / {galleryImages.length}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}